import {EXPLORA_ROUTES} from 'app/explora-routes';
import {ExploraRequestAction} from 'app/store/actions';
import {useExploraDispatch, useExploraState} from 'app/store/explora-context';
import React, {FormEvent, useState} from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import {FontColor, FontSize} from 'shared/styles/typography';
import {isIncorrectEmail} from 'shared/util/form-validation';
import ClickableIcon from '../ClickableIcon/ClickableIcon';
import DynamicImage from '../DynamicImage/DynamicImage';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import TextBody from '../TextBody/TextBody';
import TextHeadline from '../TextHeadline/TextHeadline';
import TextLegal from '../TextLegal/TextLegal';
import './Footer.scss';
import ReCAPTCHA from 'react-google-recaptcha';
import { NavigationRoutesInterface } from '../../../domain/navigation-routes';
import DynamicImageIcon from '../DynamicImageIcon/DynamicImage';

interface submitForm {
  u : string;
  f : string;
  s : string;
  c : string;
  m : string;
  act : string;
  v : string;
  'field[1]' : string;
  email : string;
  'g-recaptcha-response' : string;
}

interface router {
  routes: NavigationRoutesInterface[];
}

const Footer = ({routes} : router ) => {
  const history = useHistory();
  const state = useExploraState();
  const dispatch = useExploraDispatch();
  const [name, setName] = useState({ value: '', blurred: false, error: false });
  const [email, setEmail] = useState({ value: '', blurred: false, error: false });
  const [recaptcha, setRecaptcha] = useState('');

  const subscribeUser = async () => {
    if (!name.value || !email.value || email.error || state.isFetching) {
      return;
    }

    try {
      await ExploraRequestAction.subscribeUser(dispatch, name.value, email.value, true);
      setName({ value: '', blurred: false, error: false });
      setEmail({ value: '', blurred: false, error: false });
    } catch {}
  };

  const submitForm = (event : FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.currentTarget.submit();
    subscribeUser();
  }

  return (
    <>
      <footer className="footer-container">
        <div className="footer-container__logo-container">
          <ClickableIcon ariaLabel="explora logo" onClick={() => history.push(EXPLORA_ROUTES.Home)}>
            <DynamicImageIcon className="footer-container__explora-logo" imageName="footer-logo" alt="explora" />
          </ClickableIcon>
        </div>
        <div className="footer-container__map-container">
          <TextHeadline bold component="h1" color={FontColor.SecondaryMain} size={FontSize.Small} style={{ textAlign: 'left' }}>
            Mapa del sitio
          </TextHeadline>
          <div className="footer-container__link-container">
            {routes.map(({ label, path }) => (
              <NavLink to={path} activeClassName="footer-container__active-link" key={path} className="footer-container__link">
                <TextBody component="p" color={FontColor.SecondaryMain} size={FontSize.Medium}>
                  {label}
                </TextBody>
              </NavLink>
            ))}
            <NavLink to={'/sitemap'} activeClassName="footer-container__active-link" className="footer-container__link">
                <TextBody component="p" color={FontColor.SecondaryMain} size={FontSize.Medium}>
                  Mapa del Sitio
                </TextBody>
            </NavLink>
          </div>
        </div>


        <div className="footer-container__subscribe-container">
          <form method="POST"
                action="https://exploraproducciones.activehosted.com/proc.php"
                id="_form_1_"
                noValidate={true} target="_blank">
            <input type="hidden" name="u" value="1" />
            <input type="hidden" name="f" value="1" />
            <input type="hidden" name="s" />
            <input type="hidden" name="c" value="0" />
            <input type="hidden" name="m" value="0" />
            <input type="hidden" name="act" value="sub" />
            <input type="hidden" name="v" value="2" />



            <TextHeadline bold component="h1" color={FontColor.SecondaryMain} size={FontSize.Small} style={{ marginBottom: '1rem' }}>
              ¡Sé un explorer!
            </TextHeadline>
            <TextBody component="p" size={FontSize.Medium} color={FontColor.SecondaryMain}  style={{'margin':'1.25rem 0rem'}}>
              Únete a nuestra comunidad y recibe todo el contenido que necesitas para convertirte en un podcaster profesional.
            </TextBody>
            <label htmlFor="subscription-name">
              <TextBody component="span" color={FontColor.SecondaryMain}>
                Nombre Completo
              </TextBody>
            </label>
            <input
              id="subscription-name"
              name={"field[1]"}
              placeholder="Nombre completo"
              className="footer-container__input"
              value={name.value}
              onChange={({ target }) => setName({ value: target.value, blurred: name.blurred, error: name.error })}
            />
            <label htmlFor="subscription-email">
              <TextBody component="span" color={FontColor.SecondaryMain}>
                Correo electrónico
              </TextBody>
            </label>
            <input
              id="subscription-email"
              name={"email"}
              placeholder="Correo electrónico"
              className="footer-container__input"
              value={email.value}
              onChange={({ target }) => setEmail({ value: target.value, blurred: email.blurred, error: isIncorrectEmail(target.value) })}
              onBlur={() => setEmail({ value: email.value, blurred: true, error: email.error })}
            />
            {email.blurred && email.error && (
              <TextBody component="span" color={FontColor.Error}>
                * Por favor ingresa un correo válido
              </TextBody>
            )}
            <div>
              <ReCAPTCHA
                  sitekey="6LcwIw8TAAAAACP1ysM08EhCgzd6q5JAOUR1a0Go"
                  onChange={(value)=>
                  {
                    setRecaptcha(value == null ? '' : value);
                    console.log(value)
                  }
                  }
              />
            </div>
            <div className="footer-container__button-container">
              <PrimaryButton
                disabled={!name.value || !email.value || email.error || state.isFetching || recaptcha === ''}
                backgroundColor={FontColor.PrimaryLight}
                //onClick={subscribeUser}
                type={"submit"}
                style={{ margin: '0 1rem 1rem 0' }}
              >
                <TextBody component="span" size={FontSize.Medium}>
                  Suscribirse
                </TextBody>
              </PrimaryButton>
              <TextLegal className="footer-container__terms-text" component="span" color={FontColor.SecondaryMain} size={FontSize.Small}>
                <a href={require('shared/assets/files/PPMDP.pdf')} target={'_blank'} style={{color:'white'}}>Al dar “click” en Suscribirme aceptas nuestras políticas y tratamiento de datos</a>
              </TextLegal>
            </div>
          </form>
        </div>
      </footer>
      <div className="footer-container__copyright-container">
        <TextBody component="p" color={FontColor.SecondaryMain} size={FontSize.Small}>
          Copyright 2020 Explora Producciones | Powered by Explora Producciones
        </TextBody>
      </div>
    </>
  );
};

export default Footer;
